<template>
    <div class="modal fade" id="editEndorsement" tabindex="-1" role="dialog" aria-labelledby="editEndorsementTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-weight-bold" id="editEndorsementTitle">{{crewEndorse.crew}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="setAllNull">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <div class="form-group">
                                        <label for="batchNoEdit" class="font-weight-bold">Batch No :</label>
                                        <span class="form-control form-control-lg" v-if="!isActive">{{crewEndorse.batch ? crewEndorse.batch.batch_no : ''}}</span>
                                        <multiSelect v-model="crewEndorse.batch" :options="batchKeyDetails" :custom-label="batchNoDtls" v-if="isActive"
                                                      placeholder="Search Batch no."
                                                      :select-label="'Select'"
                                                      label="Batch No"
                                                      track-by="id"
                                                      :optionsLimi="1000"
                                                      id="batchNoEdit"
                                                      class="p-0 form-control">
                                        </multiSelect>
                                    </div>

                                    <div class="form-group">
                                        <label for="vessel" class="font-weight-bold">Intended Vessel:</label>
<!--                                        <input type="text" readonly class="form-control form-control-sm text-muted border-top-0 border-left-0 border-right-0" v-if="crewEndorse.batch" v-model="crewEndorse.batch.vessel" id="vessel" aria-describedby="endorsedBy" placeholder="Enter email">-->
                                        <span class="form-control form-control-sm" id="vessel">{{crewEndorse.batch ? crewEndorse.batch.vessel : ''}}</span>
                                    </div>

                                    <div class="form-group row">
                                        <label for="endorseCheckIn" class="col-sm-5 col-form-label font-weight-bold">Endorsed Check-In :</label>
                                        <div class="col-sm-6">
                                            <input type="date"
                                                   class="form-control form-control-sm"
                                                   id="endorseCheckIn" placeholder="Email"
                                                   v-model="crewEndorse.endorsed_check_in"
                                                   :disabled="!isActive">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="endorseCheckOut" class="col-sm-5 col-form-label font-weight-bold">Endorse Check-Out :</label>
                                        <div class="col-sm-6">
                                            <input type="date"
                                                   class="form-control form-control-sm"
                                                   id="endorseCheckOut"
                                                   v-model="crewEndorse.endorsed_check_out"
                                                   :disabled="!isActive">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="purposesDiv" class="font-weight-bold">Purposes :</label>
                                        <div class="col-sm-9 text-left ml-4" id="purposesDiv">
                                            <div class="form-check mt-2" v-for="purpose in purposes" :key="purposes.id">
                                                <input class="form-check-input" type="checkbox" :id="'purpose'+purpose.id" :value="purpose.id" v-model="crewEndorse.purposes" :disabled="!isActive">
                                                <label class="form-check-label ml-3 custom-text" :for="'purpose'+purpose.id">{{titleCase(purpose.description)}}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class=" font-weight-bold">PCR File:</label>
                                        <div class="col-sm-12">
                                            <div class="table-responsive-sm">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" class="p-1">Swab Date</th>
                                                            <th scope="col" class="p-1 text-center">Days to Expire</th>
                                                            <th scope="col" class="p-1 text-center">View</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr v-if="crewEndorse.pcrFile" v-bind:class="checkExpiredPCR(crewEndorse.pcrFile)">
                                                            <td class="p-1">{{crewEndorse.pcrFile.pcr_swab_date | moment("DD MMM YYYY")}}</td>
                                                            <td class="p-1 text-center">{{crewEndorse.pcrFile.days_to_expire}}</td>
                                                            <td class="p-1 text-center">
                                                                <button class="btn btn-xsm tnkc-secondary"
                                                                        v-if="crewEndorse.pcrFile != null"
                                                                        v-on:click="viewPCR(crewEndorse.pcrFile.id)">
                                                                    <font-awesome-icon icon="file"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table >
                                            </div>

                                           <!-- <button class="btn btn-sm tnkc-secondary ml-3">
                                                <font-awesome-icon icon="file"/>
                                            </button>
                                            <sup>{{crewEndorse.pcrFile ? crewEndorse.pcrFile.issued_date : ''}}</sup>
                                            <small id="emailHelp" class="form-text text-muted">We'll never share your pcr with anyone else.</small>-->
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 border-left text-left">
                                    <div class="form-group" v-if="isCrewOfficer || isSystemAdmin">
                                        <label for="editRemarks" class="font-weight-bold">Remarks :</label>
                                        <textarea
                                                class="form-control"
                                                id="editRemarks"
                                                style="height: 100px; resize: none;" rows="3"
                                                maxlength="200"
                                                placeholder="Add Remarks Here.."
                                                :disabled="!isActive"
                                                v-model="newRemarks.remarks"/>
                                    </div>

                                    <div class="form-group row ">
                                        <label class="font-weight-bold ml-3">Previous Remarks :</label>
                                    </div>

                                    <div class="form-group custom-scroll remarks-wrapper"  style="height:180px;">
                                        <div class="mr-2">
                                            <div class="card mb-3" v-for="(remark,index) in remarks" :key="remark.id" :id="'cardRemarks'+index">
                                                <div class="card-body">
                                                    <div class="card-title custom-label text-dark border-bottom">{{remark.subject ? remark.subject : '---'}}</div>
                                                    <div class="card-text">
                                                        <p>{{remark.remarks}}</p>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="row" style="font-size: 12px;" >
                                                                <div class="col-sm-6">
                                                                    <small class="text-muted">Created At : </small> <small class="font-weight-bold">{{remark.created_at | moment("DD MMM YYYY - HH:mm") }}</small>
                                                                </div>
                                                                <div class="col-sm-6 border-left border-dark">
                                                                    <small class="text-muted">By : </small><small class="font-weight-bold">{{remark.remark_by}}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="border">

                                    <div class="form-group row mt-3">
                                        <label for="endorsedBy" class="col-sm-5 col-form-label">Endorsed By:</label>
                                        <div class="col-sm-7">
                                            <span id="endorsedBy" class="form-control form-control-sm text-muted">{{crewEndorse.endorsedBy }}</span>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="endorsedAt" class="col-sm-5 col-form-label">Endorsed At:</label>
                                        <div class="col-sm-7">
                                            <span id="endorsedAt" class="form-control form-control-sm text-muted">{{crewEndorse.endorsedAt | moment("DD MMM YYYY - HH:mm") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn tnkc-warning" v-if="!isActive  && crewEndorse.is_active && ( isCrewOfficer|| isDocAssistant || isDocSupervisor || isSystemAdmin) && !crewEndorse.isBooked" @click="isActive = !isActive">
                        <font-awesome-icon icon="edit"/>
                        Edit
                    </button>


                    <button type="button" class="btn tnkc-success" v-if="isActive" @click="save">
                        <font-awesome-icon icon="save"/>
                        Save changes
                    </button>

                    <button type="button" class="btn tnkc-danger" v-if="isActive" @click="isActive = !isActive">
                        <font-awesome-icon icon="times"/>
                        Cancel
                    </button>

                    <button type="button" class="btn btn-secondary" v-if="!isActive"  data-dismiss="modal">
                        <font-awesome-icon icon="times"/>
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  import {appMixins} from '../../../mixins/app.mixins';
  import {mapActions,mapGetters} from 'vuex';
  import MultiSelect from 'vue-multiselect';

  export default {
    name: 'endorseDtlsModal',
    mixins:[appMixins],
    props: {
      search: {type: Function},
      updateCrewEndorsementDtls: {type: Function},
      crewEndorse: {type: Object},
      newRemarks: {type: Object},
    },
    components:{
      MultiSelect,
    },

    data(){
      return{
        value:{id:'',batch_no:'',vessel:''},
        isActive : false,
      }
    },

    methods :{
      ...mapActions(['getPurposeList','getBatchKeyDetails','getCrewEndorseDetails','setNullNewRemark','setNullRemarks', 'getPCRFile']),

      batchNoDtls({id,batch_no}){
        return `${batch_no}`;
      },

      save(){
        this.updateCrewEndorsementDtls();
        this.isActive = false;
      },

      setAllNull(){
        this.setNullRemarks();
      },

      checkExpiredPCR(obj){
        // console.log(obj);
        if (obj.days_to_expire < 0 ){
          return 'bg-expired';
        }
      },

      viewPCR(id){
        this.getPCRFile({pcr_id : id}).then((res)=>{
          if (res == true){
            this.viewPdfFile(this.pcrFile);
          }
        });
      },
    },

    computed : {
      ...mapGetters(['purposes','batchKeyDetails','remarks','pcrFile']),

    },

    created() {
       this.getPurposeList();
    },

    mounted() {
      $("#editRemarks").on('keydown', function(event) {
        if (this.selectionStart == 0 && event.keyCode >= 65 && event.keyCode <= 90 && !(event.shiftKey) && !(event.ctrlKey) && !(event.metaKey) && !(event.altKey)) {
          let $t = $(this);
          event.preventDefault();
          let char = String.fromCharCode(event.keyCode);
          $t.val(char + $t.val().slice(this.selectionEnd));
          this.setSelectionRange(1,1);
        }
      });
    },
  };
</script>

<style scoped>
    .form-control-lg {
        height: calc(1.3em + 1rem + 1px) !important;
        padding: 0.4rem 0.9rem !important;;
        font-size: 1.23rem !important;;
        line-height: 1.3 !important;;
        border-radius: 0.1rem !important;;
    }


    .remarks-wrapper{
        overflow-y: scroll;
        overflow-x: hidden;
    }

    input[type=checkbox] {
        transform: scale(2);
    }

    div::-webkit-scrollbar{
        width: 10px !important;
    }

    .btn-xsm, .btn-group-xsm > .btn {
        padding: 0.20rem 0.2rem;
        font-size: 0.870rem;
        line-height: 1.3;
        border-radius: 0.25rem;
    }
    .bg-expired {
      background-color: #ffc8bd;
    }
</style>
